<!--文件在线预览-->
<template>
  <div class="file-pre">
    <iframe :src="officeUrl" :style="'width: 100%; height:'+min_height+'px'"/>
  </div>
</template>

<script>
export default {
  name: "filePre",
  data(){
    return{
      type:'',
      officeUrl:'',
      min_height:document.documentElement.clientHeight - 90,
    }
  },
  props: {
    fileUrl: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  watch: {
    fileUrl(newVal, oldVal) {
      if (newVal != oldVal) {
        this.type=newVal.substring(newVal.lastIndexOf('.')+1)
        if (this.type!='pdf' && this.type!='PDF' && this.type!='mp4' && this.type!='text' && this.type!='txt' && this.type!='jpg' && this.type!='png' && this.type!='jpeg'){
          let url = encodeURIComponent(newVal)
          this.officeUrl = 'http://view.officeapps.live.com/op/view.aspx?src='+url
        }else {
          this.officeUrl =newVal
        }
      }
    }
  },
  mounted() {
    this.type=this.fileUrl.substring(this.fileUrl.lastIndexOf('.')+1)
    if (this.type!='pdf' && this.type!='PDF' && this.type!='mp4' && this.type!='text' && this.type!='txt' && this.type!='jpg' && this.type!='png' && this.type!='jpeg'){
      let url = encodeURIComponent(this.fileUrl)
      this.officeUrl = 'http://view.officeapps.live.com/op/view.aspx?src='+url
    }else {
      this.officeUrl =this.fileUrl
    }
  }
}
</script>
<style scoped lang="scss">

</style>